"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Mixin class for Attachments
 */
var AttachmentMixin = /** @class */ (function () {
    function AttachmentMixin() {
    }
    /**
     * Get URL for attachment with given file ID
     * @param callback
     */
    AttachmentMixin.prototype.buildAttachmentUrl = function (fileId) {
        var _a;
        return "".concat(this.apiRoot, "/attachments/").concat(encodeURIComponent(fileId), "?ak=").concat(encodeURIComponent((_a = this.local) === null || _a === void 0 ? void 0 : _a.apiKey));
    };
    return AttachmentMixin;
}());
exports.default = AttachmentMixin;
//# sourceMappingURL=AttachmentMixin.js.map